import React, { useEffect } from 'react'

import { AppAntSwitch } from '@components'
import { showDropoffOffice, officesPickoff } from '@signals'


export default function AppCommonFiltersShowDropoffOffices({ ...props }) {

	useEffect(() => {
		if(officesPickoff.value) showDropoffOffice.value = true
	}, [officesPickoff.value])

	return <AppAntSwitch
		falseText="Pick-up only"
		trueText="Pick-up & drop-off"
		checked={showDropoffOffice.value}
		onChange={newValue => showDropoffOffice.value = newValue.target.checked}
		{...props}
	/>
}